"use client";
import { jsxs as i, jsx as r } from "react/jsx-runtime";
import { withCmsDataHandling as f } from "../../../handlers/withCmsDataHandling/withCmsDataHandling.js";
import y from "../../layout/Container/Container.js";
import { useLanguage as h, Grid as m, Button as x, Heading as P, Paper as S, sharedHandler as k } from "@ingeniorforeningen/figurine-core";
import { forwardRef as T, Fragment as w } from "react";
import D from "./parts/SingleTrackProgramEntry.js";
import { singleTrackProgramDeliveryApiParser as N } from "./SingleTrackProgram.helpers.js";
import '../../../assets/SingleTrackProgram.css';const _ = "_root_melg7_2", j = {
  root: _
}, a = T(
  (l, t) => {
    const { days: o, downloadLink: e, ...s } = l, { language: g } = h();
    return /* @__PURE__ */ i(y, { ref: t, ...s, size: "xl", children: [
      e && /* @__PURE__ */ r(m, { container: !0, columns: 12, mb: "xl", children: /* @__PURE__ */ r(m, { item: !0, span: 12, fill: !1, justify: "center", children: /* @__PURE__ */ r(
        x,
        {
          icon: "Download",
          href: e.href,
          target: e.target,
          variant: "outline",
          text: e.text,
          fullWidth: !0
        }
      ) }) }),
      o && o.map(({ date: c, entries: n }, p) => /* @__PURE__ */ i(w, { children: [
        /* @__PURE__ */ r(
          P,
          {
            type: "h2",
            text: c.toLocaleString(g, {
              day: "numeric",
              month: "long",
              year: "numeric"
            }),
            mt: "xs",
            mb: "lg"
          }
        ),
        n && /* @__PURE__ */ r(S, { className: j.root, ref: t, p: "xs", px: 0, children: n.map((d, u) => /* @__PURE__ */ r(D, { ...d }, `programEntry${u}`)) })
      ] }, `programDay${p}`))
    ] });
  }
);
a.displayName = "SingleTrackProgram";
const v = f({
  Component: k(
    a
  ),
  deliveryApiParser: N
});
v.displayName = a.displayName;
export {
  j as S,
  a as _SingleTrackProgram,
  v as default
};
